/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_Reason_Broken_DetailInputs */

const en_marketing_contact_reason_broken_detail = /** @type {(inputs: Marketing_Contact_Reason_Broken_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License holders get fixes fast. Include what you expected and what happened instead.`)
};

const es_marketing_contact_reason_broken_detail = /** @type {(inputs: Marketing_Contact_Reason_Broken_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quienes tienen licencia reciben correcciones rápido. Cuenta qué esperabas y qué ocurrió en su lugar.`)
};

const fr_marketing_contact_reason_broken_detail = /** @type {(inputs: Marketing_Contact_Reason_Broken_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les détenteurs de licence sont corrigés vite. Précisez ce que vous attendiez et ce qui s'est produit.`)
};

/**
* | output |
* | --- |
* | "License holders get fixes fast. Include what you expected and what happened instead." |
*
* @param {Marketing_Contact_Reason_Broken_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_reason_broken_detail = /** @type {((inputs?: Marketing_Contact_Reason_Broken_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_Reason_Broken_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_reason_broken_detail(inputs)
	if (locale === "es") return es_marketing_contact_reason_broken_detail(inputs)
	return fr_marketing_contact_reason_broken_detail(inputs)
});